import styled from "styled-components";
import React, { Component } from "react";
import { rem } from "polished";
import PropTypes from "prop-types";
import ScoreC from "./ScoreC";
import ScoreNumber from "./ScoreNumber";
import ScoreStars from "./ScoreStars";

const Container = styled.div`
  margin: ${rem("5px")};
  padding: ${rem("5px")};
  &.tight {
    margin: 0;
    padding: 0;
  }
  position: relative;
  box-sizing: border-box;
  transform: translate3d(0, 0, 0);
`;

class ScoreVisualizer extends Component {
  render() {
    return (
      <Container {...this.props}>
        <ScoreStars score={this.props.score} percent={this.props.percent} />
        <ScoreNumber tight={this.props.tight} score={this.props.score} />
        <ScoreC percent={this.props.percent} />
      </Container>
    );
  }
}

ScoreVisualizer.propTypes = {
  score: PropTypes.number,
  percent: PropTypes.number,
  tight: PropTypes.bool
};

ScoreVisualizer.defaultProps = {
  score: 0,
  percent: 0,
  tight: false
};

export default ScoreVisualizer;



// WEBPACK FOOTER //
// ./src/ui/score/ScoreVisualizer.js